import React, { useCallback, useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import useIGRGameUrl from '../hooks/useIGRGameUrl';
import useTSReporting from '../hooks/useTSReporting';
import useLogger from '../hooks/useLogger';
import { EntryContext } from '../contexts/entryContext';
import TagManager from 'react-gtm-module';
import ERROR_MESSAGES from '../contants/errorConstants';

const PlayButton = ({ name, className, tag, revealGame, asset }) => {
    const navigate = useNavigate();
    const [fetchUrlTrigger, setFetchUrlTrigger] = useState(false);
    const [shouldNavigate, setShouldNavigate] = useState(false);
    const [reportErrorCode, setReportErrorCode] = useState(false);
    const { setIgrGameUrl, setErrorCode, setSelectedRevealGame } = useContext(EntryContext);

    const { gameUrl, loading, error } = useIGRGameUrl(fetchUrlTrigger ? revealGame : null);

    const { completed: reportCompleted, error: reportError, loading: reportLoading } = useTSReporting(fetchUrlTrigger ? revealGame : null);

    // Log error when TS Reporting call failed
    useLogger(reportErrorCode);

    useEffect(() => {
        if (reportError) {
            //? ERROR_GAME_FEED_REPORT_FAILED: The TS report API call failed with an error. We should not block the player flow, just log it.
            setReportErrorCode(ERROR_MESSAGES.GAME_FEED_REPORT_FAILED);
        }
    }, [reportError]);

    const handlePlayGame = useCallback(async () => {
        // Analytics event tracking for game started
        const tagManagerArgs = {
            dataLayer: {
                event: 'play_game',
                category: 'GAME_PLAYED',
                action: `GAME_STARTED_${tag}`,
            },
        };
        TagManager.dataLayer(tagManagerArgs);

        await setIgrGameUrl(gameUrl);
        navigate(`/play`, { replace: true });

        setShouldNavigate(false);
        setFetchUrlTrigger(false);
    }, [tag, gameUrl, setIgrGameUrl, navigate]);

    useEffect(() => {
        if (shouldNavigate && gameUrl && reportCompleted) {
            handlePlayGame();
        }
    }, [shouldNavigate, gameUrl, reportCompleted, handlePlayGame]);

    useEffect(() => {
        if (error) {
            //? ERROR_IGR_GAME_URL_NOT_RETURNED: The IGR game URL was not returned from the IGR service
            console.error('🔴 Error fetching game URL:', error);
            setErrorCode(ERROR_MESSAGES.IGR_GAME_URL_NOT_RETURNED);
            setFetchUrlTrigger(false);
            navigate(`/`, { replace: true });
        }
    }, [error, setErrorCode, navigate]);

    useEffect(() => {
        if (reportError) {
            //? ERROR_GAME_FEED_REPORT_FAILED: The Feed report API call failed
            //? Player flow should not break: setErrorCode(ERROR_MESSAGES.GAME_FEED_REPORT_FAILED);
            console.error('🔴 Error calling TS report URL:', reportError);
        }
    }, [reportError, setErrorCode]);

    const playHandler = () => {
        console.log('▶️ Play button clicked for:', tag);
        setSelectedRevealGame(revealGame);
        setFetchUrlTrigger(true);
        setShouldNavigate(true);
    };

    return (
        <input
            id={name}
            type='image'
            alt={asset?.alt}
            name={name}
            src={asset?.ref}
            className={`game-button ${className ? className : ''}`}
            onClick={playHandler}
            aria-label='Play'
            disabled={loading || reportLoading || fetchUrlTrigger || !revealGame?.game_id}
            title={loading ? 'Loading game...' : 'Play Game'}
        />
    );
};

export default PlayButton;
